import { useDispatch, useSelector } from "react-redux";
import { ChatState } from "../../base/models/model";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChatActions } from "../../store/slices/chat_slice/chat_slice";
import eyeview from "../../styles/images/eyeview.svg"

const SupervisorWhisperStatus = () => {

    const chatReducer: ChatState = useSelector((state: any) => state.chatReducer);
    const { currentSession, supervisorWhisperStatus } = chatReducer;
    const agentName: any = sessionStorage.getItem('agentNameForSupervisor');
    const supervisorStatus: any = sessionStorage.getItem('supervisorWhisperStatus');
    const dispatch = useDispatch();
    const [elapsedTime, setElapsedTime] = useState<any>(0);
    const [startTime, setStartTime] = useState(new Date());
    const location = useLocation();
    const navigate = useNavigate();
    const currentPath = location.pathname;

    const handleWhisperChats = (val: any) => {
        console.log('val', val, 'currentSession', currentSession);
        // sessionStorage.setItem('supervisorStatus', 'false');
        if (currentSession?.supervisorStatus == val) {
            dispatch(ChatActions.chatSessionList({ ...currentSession, supervisorStatus: 'false' }));
            dispatch(ChatActions.currentChatSession({ ...currentSession, supervisorStatus: 'false' }));
            dispatch(ChatActions.chatAgentAssistReload(false))
            dispatch(ChatActions.sessionRemoveAfterEnd(currentSession?.sessionId));
            if (window.location.pathname === '/chatscreenagent') { navigate(-1) }
            // navigate('/allactivity');
            return;
        } else if (val == 'view') {
            dispatch(ChatActions.chatSessionList({ ...currentSession, supervisorStatus: 'view' }));
            dispatch(ChatActions.currentChatSession({ ...currentSession, supervisorStatus: 'view' }));
        } else if (val == 'whisper') {
            dispatch(ChatActions.chatSessionList({ ...currentSession, supervisorStatus: 'whisper' }));
            dispatch(ChatActions.currentChatSession({ ...currentSession, supervisorStatus: 'whisper' }));
        }
    }


    function formatElapsedTime(time: any) {
        const seconds = Math.floor(time / 1000) % 60;
        const minutes = Math.floor(time / 1000 / 60) % 60;
        const hours = Math.floor(time / 1000 / 60 / 60) % 24;
        return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    }



    useEffect(() => {
        if (elapsedTime == 0) {
            setStartTime(new Date());
        }
        if (!['view', 'whisper', 'barge'].includes(supervisorWhisperStatus)) {
            setElapsedTime(0);
        } else {
            const interval = setInterval(() => {
                const now = new Date();
                const timeElapsed = now.getTime() - startTime.getTime();
                setElapsedTime(timeElapsed);
            }, 1000);
            return () => clearInterval(interval);
        }

    }, [elapsedTime, supervisorWhisperStatus]);

    return (
        <>{currentPath == '/chatscreenagent' ?
            <div className="whisperbox">
                <h3>{currentSession?.calledPersonDetails?.firstName ? (currentSession?.calledPersonDetails?.lastName ? (currentSession?.calledPersonDetails?.firstName + " " + currentSession?.calledPersonDetails?.lastName) : currentSession?.calledPersonDetails?.firstName) : 'New customer'}<span>{[undefined, null, ''].includes(agentName) ? 'Not available' : agentName}</span></h3>
                <div className='viewSvg'>
                    {
                        currentSession?.supervisorStatus === 'view'
                            ? <img src={eyeview} alt="eye-view-icon" />
                            : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_2059_58275)">
                                    <path d="M19.1218 11.0742C18.4609 7.75196 15.5251 5.23926 12.0117 5.23926C8.50395 5.23926 5.57085 7.74406 4.90405 11.0586C3.79295 11.8281 3.06055 13.1033 3.06055 14.5352C3.06055 16.7393 4.77935 18.5938 6.97365 18.7579C6.99225 18.7599 7.01075 18.7608 7.03025 18.7608C7.21875 18.7608 7.40425 18.6876 7.54585 18.5567C7.70405 18.4102 7.79485 18.2032 7.79485 17.9883V11.083C7.79485 10.8691 7.70505 10.6621 7.54685 10.5156C7.39255 10.372 7.18355 10.2998 6.97455 10.3115C6.87105 10.3193 6.77435 10.3487 6.67305 10.3639C7.52095 8.24336 9.59225 6.73916 12.0116 6.73916C14.4327 6.73916 16.5053 8.24546 17.3519 10.3684C17.242 10.3512 17.1368 10.32 17.0243 10.3115C16.8036 10.3037 16.6073 10.372 16.453 10.5156C16.2958 10.6621 16.2059 10.8691 16.2059 11.083V17.9883C16.2059 18.2031 16.2967 18.4102 16.4549 18.5576C16.5965 18.6885 16.782 18.7607 16.9705 18.7607C16.9891 18.7607 17.0076 18.7597 17.0262 18.7587C19.2215 18.5937 20.9403 16.7392 20.9403 14.5351C20.9403 13.1138 20.2195 11.8456 19.1218 11.0742Z" fill="#000" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_2059_58275">
                                        <rect width="24" height="24" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>}
                    <p>{currentSession?.supervisorStatus == 'view' ? ' Viewing' : ''}</p>
                    <p>{currentSession?.supervisorStatus == 'whisper' ? ' Whispering' : ''}</p>
                    <span>{formatElapsedTime(elapsedTime)}</span>
                </div>
                {/* {supervisorStatus == 'barge' ? 'Barging' : ''} */}
                <div className="whisperbtns">
                    {currentSession?.supervisorStatus == 'view' ? <button className="stops" onClick={() => { handleWhisperChats('view'); dispatch(ChatActions.supervisorWhisperStatus('')); }}>Stop Viewing</button> : <button onClick={() => handleWhisperChats('view')}>View</button>}
                    {currentSession?.supervisorStatus == 'whisper' ? <button className="stops" onClick={() => { handleWhisperChats('whisper'); dispatch(ChatActions.supervisorWhisperStatus('')); }}>Stop Whispering</button> : <button onClick={() => handleWhisperChats('whisper')}>Whisper</button>}
                    {/* {currentSession?.supervisorStatus == 'barge' ? <button className="stops" onClick={() => handleWhisperChats('barge')}>Stop Barging</button> : <button onClick={() => handleWhisperChats('barge')}>Barge</button> } */}
                    {/* <button onClick={() => handleWhisperChats('view')}> {currentSession?.supervisorStatus == 'view' ? 'Stop Viewing' : 'View'}</button>
                    <button onClick={() => handleWhisperChats('whisper')}> {currentSession?.supervisorStatus == 'whisper' ? 'Stop Whispering' : 'Whisper'}</button>
                    <button onClick={() => handleWhisperChats('barge')}> {currentSession?.supervisorStatus == 'barge' ? 'Stop Barging' : 'Barge'}</button> */}
                </div>
            </div>
            : ''}</>)
}

export default SupervisorWhisperStatus;